<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  export default {
    mounted() {

    },
    destroyed() {
      localStorage.removeItem('language')
    }
  }
</script>

<style lang="scss">
*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
body{
  color: #333;
}
h4 {
  font-size: 38px;
  line-height: 1.5;
  margin-bottom: .7em;
  color: #333;
}
p{
  font-size: 16px;
  text-align: justify;
  line-height: 2;
  margin-bottom: 1.5em;
}
a, a:focus, a:hover {
  cursor: pointer;
  outline: none;
  text-decoration: none;
  color: #333;
}
img{
  max-width: 100%;
  height: auto;
}
.fl{
  float: left;
}
.fr{
  float: right;
}
.fn-clear{
  zoom: 1;
}
.fn-clear:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.contain {
  max-width: 1920px;
  margin: 0 auto;
}
.pageWidth {
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
}
@media (max-width: 1000px) {
  .pageWidth {
    padding: 0 .6667rem;
  }
}
@media screen and (min-width: 100px) {
  .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
    color: #da3915;
    margin-top: 0;
    font-size: 16px;
    display: none;
  }
  .mainNav>li .el-submenu__title {
    font-size: 16px !important;
    color: #000 !important;
    -webkit-transition: color .3s;
    transition: color .3s;
  }
}
.el-menu--horizontal>.el-submenu .el-submenu__title {
  height: 44px !important;
  line-height: 44px !important;
  color: #909399;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
}
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
  background-color: #fff;
  float: none;
  height: .48rem;
  line-height: .48rem;
  padding: 0 .133333rem;
  color: #909399;
}
.el-menu--popup-bottom-start {
  margin-top: 0 !important;
}


:root {
  --state-success: #2CA860;
  --state-danger: #CA3F64;
  --state-warning: #FF7E33;
  --state-link: #457AFF;
  --bg-1: #111212;
  --bg-2: #191B1B;
  --bg-overlay: rgba(23, 24, 26, 0.6);
  --fill1: #fff;
  --fill2: #323439;
  --fill3: #242529;
  --fill4: #1F1F21;
  --fill5: #c9dbf4;
  --fill6: #251D00;
  --fill-opacity2: rgba(50, 52, 57, 0.2);
  --border-0: #232324;
  --border-1: #2A2A2B;
  --border-2: #373738;
  --text-1: #fff;
  --text-2: #D4D6DB;
  --text-3: #9B9FA8;
  --text-4: #474A52;
  --text-5: #111212;
  --text-6: #c9dbf4;
  --line-1: #5E626B;
  --line-2: #212121;
  --line-3: #000;
  --danger-1: #CA3F64;
  --danger-2: #291C21;
  --success-1: #2CA860;
  --success-2: #192621;
  --warning-1: #FF7E33;
  --warning-2: #2E221D;
  --link-1: #457AFF;
  --link-2: #E8EEFE;
  --link-hover: #5283FF;
  --link-active: #4071ED;
  --color-bg-base: #111212;
  --color-text-base: #fff;
  --color-text: rgba(255, 255, 255, 0.8);
  --color-text-secondary: rgba(255, 255, 255, 0.6);
  --color-text-tertiary: rgba(255, 255, 255, 0.35);
  --color-text-highlight: #fff;
  --color-text-placeholder: rgba(255, 255, 255, 0.35);
  --color-border: rgba(55, 55, 56, 1);
  --color-bg-overlay: rgba(0, 0, 0, 0.40);
  --divider: rgba(55, 55, 56, 1);
  --mask-layer: rgba(0, 0, 0, 0.75);
  --primary-main: #fff;
  --primary-border-color: #fff;
  --primary-contrast-text: #111212;
  --primary-main-hover: #EDEDED;
  --primary-main-active-color: #fff;
  --secondary-main: #323439;
  --secondary-border-color: #9B9FA8;
  --secondary-contrast-text: #fff;
  --secondary-main-hover: #3B3D41;
  --secondary-main-active-color: #292B2F;
  --ghost-main: #191B1B;
  --ghost-border-color: #9B9FA8;
  --ghost-contrast-text: #fff;
  --ghost-main-hover: #191B1B;
  --ghost-main-active-color: #323439;
  --error-main: #CA3F64;
  --error-border-color: #CA3F64;
  --error-contrast-text: #fff;
  --error-main-hover: #EC5474;
  --error-main-active-color: #DF4768;
  --success-main: #2CA860;
  --success-border-color: #2CA860;
  --success-contrast-text: #fff;
  --success-main-hover: #38B66D;
  --success-main-active-color: #2CA960;
  //--empty-background: url(/assets/no-data-dark.png) no-repeat center;
  --empty-background: '';
  --chart-1: #5B9CF6;
  --chart-2: #66BB6A;
  --chart-3: #FFA726;
  --chart-4: #F7525F;
  --chart-5: #26C6DA;
  --chart-6: #BA68C8;
  --chart-7: #DC7A47;
  --chart-8: #00918A;
  --chart-9: #FF99C3;
  --chart-10: #7C61F2;
  --chart-11: #A6CE40;
  --chart-12: #AC6464;
  --chart-13: #19DAAC;
  --chart-14: #BF923C;
  --chart-15: #BDD8FF;
  --chart-16: #A5D9A7;
  --chart-17: #FFD8A0;
  --chart-18: #ffdfe1;
  --chart-19: #a9f2fa;
  --chart-20: #F6DCFA;
  --chart-21: #F0CFBD;
  --chart-22: #A8F3F0;
  --chart-23: #FFC2DB;
  --chart-24: #D2C8FB;
  --chart-25: #CAE193;
  --chart-26: #F3E7E7;
  --chart-27: #9AFBE5;
  --chart-28: #F0E4CE;
  --scrollbar-color: #474A52;
}
.gLSZOv {
  height: 48px;
}

</style>
